/**
 * A utility function for creating the name of the completed state of an action item during the walkthrough.
 *
 * @param {String} actionItemName - the action item name
 * @returns {String} the name of the completed state of an action item
 */
export function getActionItemCompleteName(actionItemName) {
  return `${actionItemName}_COMPLETE`;
}